import API from './index';

const api = {
    getAllHospital() {
        return API.basicAPI({
            url: '/hospital/get-all-hospital',
            method: 'GET',
        });
    },
};

export default api;
